'use client';

import { type FC, useEffect } from 'react';
import type { StepTrackingContext } from '@/lib/flow/route-renderers';
import { useDataDog } from './use-data-dog-rum';
import { useTrackVirtPathAndPageMeta } from './use-track-virt-path-and-page-meta';

export const EnergySolutionsFlowTracking: FC<StepTrackingContext> = ({ stepId, state, viewName }) => {
  const trackVirtPathAndPageMeta = useTrackVirtPathAndPageMeta();

  useDataDog({
    checkout: 'Energy Solutions',
    state,
    viewName,
  });

  useEffect(() => {
    trackVirtPathAndPageMeta(
      `/checkout-b2c-energieloesungen-${stepId}/`,
      `Checkout B2C Energielösungen ${viewName}`,
      'Other',
    );
  }, [stepId, trackVirtPathAndPageMeta, viewName]);

  return null;
};
